import React, { createContext, useEffect, useState } from 'react';

const CacheContextAvion = createContext();

export const CacheAvionProvider = ({ children }) => {
	const [cache, setCache] = useState(JSON.parse(sessionStorage.getItem("cacheAvion")) || {});

	const setCacheCustom = () => {
		sessionStorage.setItem("cacheAvion", JSON.stringify(cache))
	}

	const clearCacheAvion = () => {
		setCache({})
	}

	return (
		<CacheContextAvion.Provider value={{ cache, setCache, setCacheCustom, clearCacheAvion }}>
			{children}
		</CacheContextAvion.Provider>
	);
};

export default CacheContextAvion;
